import { getNodeAnimation } from "./../../../_shared/node-animation/get-node-animation.js";
const hasPointerAnimatedNodes = (nodes) => nodes.some(
  (node) => getNodeAnimation(node)?.type === "POINTER" || hasPointerAnimatedNodes(node.nodes ?? [])
);
export {
  hasPointerAnimatedNodes
};
//# sourceMappingURL=has-pointer-animated-nodes.js.map
